export type TaskCommentsEditContextType = {
  editing: boolean
  content: string
  editingID: string
  startEdit: (comment: APIComment) => void
  saveEdit: () => void
  discardEdit: () => void
  deleteComment: (commentId: string) => void
  updateContent: (text: string) => void
}

export const defaultValue: TaskCommentsEditContextType = {
  editing: false,
  content: '',
  editingID: '',
  startEdit: _ => {},
  saveEdit: () => {},
  discardEdit: () => {},
  deleteComment: () => {},
  updateContent: _ => {}
}
